import React from 'react';
import { oohData } from '../utils/oohData';
import { ImageIcon, TargetIcon, BuildingIcon, UsersIcon, MessageCircleIcon, TagIcon, FileTextIcon } from 'lucide-react';
const FieldLabel: React.FC<{
  icon: React.ElementType;
  children: React.ReactNode;
}> = ({
  icon: Icon,
  children
}) => <div className="flex items-center space-x-2 mb-1.5" data-id="element-98" data-mp="2yngsa3uo3jwz">
    <Icon className="export-icon-down w-4 h-4 text-gray-400 flex-shrink-0" data-id="element-99" data-mp="2yp1qq4k3rn04" />
    <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider" data-id="element-100" data-mp="4s30391gu3l">
      {children}
    </span>
  </div>;
export const CreativeContext: React.FC = () => {
  const {
    brandContext
  } = oohData;
  return <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-101" data-mp="3mitbscpgoiph">
      <div className="flex items-center space-x-3 mb-6" data-id="element-102" data-mp="3hkrsprs1cje0">
        <div className="p-2 bg-[#1E90FF]/10 text-[#1E90FF] rounded-lg" data-id="element-103" data-mp="3hjyr157xok2q">
          <ImageIcon className="w-5 h-5" data-id="element-104" data-mp="ix41ug0hhd8z" />
        </div>
        <h2 className="text-lg font-medium text-gray-800" data-id="element-105" data-mp="e4t2pfdkhvhh">
          Creative Preview & Brand Context
        </h2>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-106" data-mp="ia2035pxt2c7">
        {/* Left column: the creative itself */}
        <div className="space-y-4" data-id="element-107" data-mp="m9khvsmgoxat">
          <div className="relative rounded-xl overflow-hidden border border-gray-100" data-id="element-108" data-mp="8iyzs64u0rdz">
            <img src={brandContext.imageUrl} alt="OOH Creative" className="w-full h-auto object-cover" data-id="element-109" data-mp="8h4j540lflfp" />
            <div className="absolute top-4 left-4 bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-sm flex items-center space-x-2" data-id="element-110" data-mp="3updv9ylhxsnn">
              <TargetIcon className="w-4 h-4 text-[#1E90FF]" data-id="element-111" data-mp="3lph5ftndenr0" />
              <span className="export-text-up text-xs font-semibold text-gray-800 uppercase tracking-wider" data-id="element-112" data-mp="3lr21xot8wgri">
                {brandContext.oohObjective}
              </span>
            </div>
          </div>
          <div className="bg-gray-50/50 p-4 rounded-xl border border-gray-100" data-id="element-113" data-mp="1jyvvcd76e9k6">
            <h3 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2" data-id="element-114" data-mp="1ovw6h2ivu2i5">
              Objective Rationale
            </h3>
            <p className="text-sm text-gray-700 leading-relaxed" data-id="element-115" data-mp="1igyolygy2zgi">
              {brandContext.objectiveRationale}
            </p>
          </div>
        </div>

        {/* Right column: brand context fields */}
        <div className="space-y-6" data-id="element-116" data-mp="18j115d6wt6oy">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-117" data-mp="18k2n4cpgrdlg">
            <div data-id="element-118" data-mp="2671c019wzh8s">
              <FieldLabel icon={BuildingIcon} data-id="element-119" data-mp="265huy8gfp25y">Brand</FieldLabel>
              <p className="text-sm font-medium text-gray-900" data-id="element-120" data-mp="217gapk79uwsw">
                {brandContext.brandName}
              </p>
            </div>

            <div data-id="element-121" data-mp="1wfon9ijex76z">
              <FieldLabel icon={TagIcon} data-id="element-122" data-mp="1wf5aeg8md8zt">Industry</FieldLabel>
              <p className="text-sm font-medium text-gray-900" data-id="element-123" data-mp="1riey83zxqxjo">
                {brandContext.industry}
              </p>
            </div>

            <div data-id="element-124" data-mp="2oybzs9kcfdwg">
              <FieldLabel icon={TargetIcon} data-id="element-125" data-mp="2oyu6k04mtaim">Market Segment</FieldLabel>
              <p className="text-sm font-medium text-gray-900" data-id="element-126" data-mp="2k4pz7frgf0h0">
                {brandContext.marketSegment}
              </p>
            </div>

            <div data-id="element-127" data-mp="2wga6y7f1ycwi">
              <FieldLabel icon={MessageCircleIcon} data-id="element-128" data-mp="2wfqnundo1igw">Brand Tone</FieldLabel>
              <p className="text-sm font-medium text-gray-900" data-id="element-129" data-mp="31fmukudqzo05">
                {brandContext.brandTone}
              </p>
            </div>
          </div>

          <div className="pt-5 border-t border-gray-100" data-id="element-130" data-mp="36gauy6nv9h71">
            <FieldLabel icon={UsersIcon} data-id="element-131" data-mp="3agupr3kyw8q0">Target Audience</FieldLabel>
            <p className="text-sm text-gray-700 leading-relaxed" data-id="element-132" data-mp="3aegwn09ul6l3">
              {brandContext.targetAudience}
            </p>
          </div>

          <div className="pt-5 border-t border-gray-100" data-id="element-133" data-mp="3k5us8wyohm8y">
            <FieldLabel icon={FileTextIcon} data-id="element-134" data-mp="3k8gz0udqvxq4">Creative Summary</FieldLabel>
            <p className="text-sm text-gray-700 leading-relaxed" data-id="element-135" data-mp="3p4o2mgio4x4w">
              {brandContext.creativeSummary}
            </p>
          </div>
        </div>
      </div>
    </div>;
};